// Function to deep compare two objects. This is a simple implementation and may not cover all edge cases
// I Think we should use a lodash for deep comparison @Adam
export const deepEqual = (a: any, b: any): boolean => {
    if (a === b) return true
    if (a === null || b === null) return false
    if (typeof a !== 'object' || typeof b !== 'object') return false
  
    if (Array.isArray(a) !== Array.isArray(b)) return false
  
    const keysA = Object.keys(a)
    const keysB = Object.keys(b)
    if (keysA.length !== keysB.length) return false
  
    for (const key of keysA) {
      if (!b.hasOwnProperty(key)) return false
      if (!deepEqual(a[key], b[key])) return false
    }
  
    return true
}

export const formatNumberWithCommas = (number: number | string): string => {
  if (number === null || number === undefined) return ''

  const num = typeof number === 'number' ? number : parseFloat(number.toString().replace(/,/g, ''))
  
  if (isNaN(num)) return ''

  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

/**
 * Scrolls to the first form element that has an error
 * This function looks for elements with data-error="true" attribute
 * and smoothly scrolls to the first one found
 */
export const scrollToFirstError = (): void => {
  const errorElements = document.querySelectorAll('[data-error="true"]')
  if (errorElements.length > 0) {
    const firstError = errorElements[0]
    firstError.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }
}

export const fetchEnvironmentUrl = (): string => {
  const url = new URL(window.location.href)
  const hostname = url.hostname

  const environmentUrls: Record<string, string> = {
    test: 'https://udc-cms-test.azurewebsites.net/',
    localhost: 'https://udc-cms-test.azurewebsites.net/',
    staging: 'https://udc-cms-staging.azurewebsites.net/'
  }

  for (const [key, value] of Object.entries(environmentUrls)) {
    if (hostname.includes(key)) {
      return value
    }
  }

  // @TODO Default to production But we need to change the actual production URL
  return 'https://udc-cms-production.azurewebsites.net/'
}